import ApiHelper from "../apiHelper";
import type { TransportAirlineApiContext } from "./airlineTransportContext";

export type DestinationTransportPayload = {
  date: string;
  time: string;
  departureAddress: string | null;
  departureAddressId: string | null;
  destinationAddress: string | null;
  destinationAddressId: string | null;
  milesAndMore: string;
  offerCode?: string;
  details?: any;
};

export function buildDestinationTransportPayload(input: any): DestinationTransportPayload {
  const offerCodeRaw = typeof input?.offerCode === "string" ? input.offerCode.trim() : "";

  const hasOfferCode = Boolean(offerCodeRaw);
  const hasDetails = input?.details !== undefined && input?.details !== null;

  const departureAddress =
    typeof input?.departureAddress === "string" ? input.departureAddress : input?.departureAddress ?? null;
  const destinationAddress =
    typeof input?.destinationAddress === "string" ? input.destinationAddress : input?.destinationAddress ?? null;

  return {
    date: input?.date ?? "",
    time: input?.time ?? "",
    departureAddress,
    departureAddressId: input?.departureAddressId ? String(input.departureAddressId) : null,
    destinationAddress,
    destinationAddressId: input?.destinationAddressId ? String(input.destinationAddressId) : null,
    milesAndMore: input?.milesAndMore ?? "",
    ...(hasOfferCode ? { offerCode: offerCodeRaw } : {}),
    ...(hasDetails ? { details: input.details } : {})
  };
}

export async function postDestinationTransportEstimation(args: {
  apiUrl: string;
  transportContext: TransportAirlineApiContext;
  payload: Record<string, any>;
  v2: { type?: string; path?: string };
  airline?: { path: (iataCode: string) => string };
}) {
  const { apiUrl, transportContext, payload, v2, airline } = args;

  if (transportContext.mode === "airline_missing_iata") {
    throw new Error("Missing iataCode");
  }

  if (transportContext.mode === "airline") {
    if (!airline?.path) {
      throw new Error("Missing airline path resolver");
    }
    const path = airline.path(transportContext.iataCode);
    const res = await ApiHelper.post(`${apiUrl}/${path}`, {}, payload);
    return res?.data;
  }

  let v2Path = "";
  if (typeof v2?.path === "string" && v2.path.trim()) {
    v2Path = v2.path.trim().replace(/^\//, "");
  } else {
    v2Path = `v2/transport/${encodeURIComponent(v2.type ?? "")}`;
  }

  const res = await ApiHelper.post(`${apiUrl}/${v2Path}`, {}, payload);
  return res?.data;
}
